// extracted by css-extract-rspack-plugin
export default {"status_progress":"StepStatus_status_progress__i2WFX"};